// Todo el contenido editable del sitio está aquí. Cambia textos, enlaces e imágenes fácilmente.

export const nav = [
  { label: "Inicio", target: "#inicio" },
  { label: "Mi historia", target: "#historia" },
  { label: "Trayectoria", target: "#trayectoria" },
  { label: "Mis proyectos", target: "#proyectos" },
  { label: "Contacto", target: "#contacto" },
];

export const hero = {
  name: "Yosimar de Paz",
  stageName: "El Compa Yosi",
  tagline: "Mi voz, mi historia y mi pasión por conectar con la gente",
  description: "Actor, locutor y empresario",
  ctaPrimary: { label: "Conoce mi historia", target: "#historia" },
  ctaSecondary: { label: "Contacto", target: "#contacto" },
};

export const biography = [
  "Soy Yosimar de Paz, conocido como El Compa Yosi: actor, locutor y empresario radicado en Huntsville, Alabama. Mi trayectoria en los medios comenzó alrededor de los 13 años en Tonalá, Chiapas.",
  "Trabajé en La Digital 89.5 FM, perteneciente al Sistema Chiapaneco de Radio, Televisión y Cinematografía, donde me conocían como El Flaco de la FM. También colaboré en Aficionarte, hecho en Chiapas, un programa musical que ofrecía un espacio a jóvenes y aficionados para cantar y mostrar su talento. Participé como operador y, durante algunos programas, como conductor provisional.",
  "Posteriormente participé como extra en Corazón salvaje, la versión de Televisa de 2009–2010. Estuve en escenas del mercado y de San Juan de Ulúa, en Veracruz, con llamados intermitentes durante aproximadamente ocho o nueve meses. Durante esa experiencia coincidí con Enrique Rocha y conocí al Negro Araiza.",
  "También participé en La jaula de oro, película de 2013 dirigida por Diego Quemada-Díez, que aborda el viaje de jóvenes migrantes hacia Estados Unidos.",
  "Hoy continúo mi trayectoria en la radio hispana como El Compa Yosi y desarrollo proyectos de contenido, marketing y emprendimiento en Huntsville, Alabama. Mi trabajo reúne la comunicación, la creatividad y el vínculo con nuestra comunidad.",
];

export const timeline = [
  {
    period: "Alrededor de los 13 años",
    title: "Inicio en La Digital 89.5 FM",
    description: "Tonalá, Chiapas, como El Flaco de la FM.",
  },
  {
    period: "Etapa en Chiapas",
    title: "Colaboración en Aficionarte",
    description: "Como operador y conductor provisional durante algunos programas.",
  },
  {
    period: "2009–2010",
    title: "Corazón salvaje",
    description: "Participación como extra, Veracruz.",
  },
  {
    period: "Película estrenada en 2013",
    title: "La jaula de oro",
    description: "Participación en la película dirigida por Diego Quemada-Díez.",
  },
  {
    period: "Actualidad",
    title: "Radio como El Compa Yosi",
    description: "Creación de contenido y emprendimiento.",
    logo: "/assets/laraza.png",
    logoAlt: "La Raza 94.7 FM / 890 AM",
  },
];

export const projects = [
  {
    id: "yosi-media-studio",
    title: "Yosi Media Studio",
    description: "Diseño web, marketing digital, contenido y automatización para negocios.",
    link: "https://yosimediastudio.com",
    logo: "/assets/ymstudio.png",
    logoLabel: "Logo: Yosi Media Studio",
  },
  {
    id: "prime-pro-connected-service",
    title: "Prime Pro Connected Service",
    description: "Conexión entre clientes y proveedores de servicios locales.",
    link: "https://primeproconnectservices.com",
    logo: "/assets/primepro.png",
    logoLabel: "Logo: Prime Pro Connected Service",
  },
  {
    id: "yosi-tv",
    title: "Yosi TV",
    description: "Mi canal de YouTube, donde comparto radio, entrevistas, podcast, historias, humor y momentos de mis proyectos.",
    link: null,
    logoLabel: "Logo: Yosi TV",
  },
  {
    id: "los-titos-restaurant",
    title: "Los Tito’s Restaurant",
    description: "Comida hondureña y mexicana en Huntsville, Alabama.",
    link: null,
    logoLabel: "Logo: Los Tito’s Restaurant",
  },
];

export const contact = {
  heading: "¿Creamos algo juntos?",
  text: "Contáctame para publicidad, entrevistas, eventos, creación de contenido y colaboraciones.",
  email: "yosimarpaz93@gmail.com",
  phone: "(256) 288-8270",
  whatsapp: "https://wa.me/12562888270",
};

// Fotografías reales
export const photos = {
  portada: "/assets/poster.jpg",
  historia: "/assets/retrato.jpg",
};

// Redes sociales: agrega el enlace real en "link" para mostrar el perfil.
// Solo se muestran los perfiles que tienen un enlace real (link distinto de null).
export const socials = [
  { id: "instagram", label: "Instagram", link: "https://www.instagram.com/elcompayosiradio/" },
  { id: "tiktok", label: "TikTok", link: "https://www.tiktok.com/@elcompayosiradio" },
  { id: "whatsapp", label: "WhatsApp", link: "https://wa.me/12562888270" },
  { id: "facebook", label: "Facebook", link: null },
  { id: "youtube", label: "YouTube", link: null },
  { id: "x", label: "X (Twitter)", link: null },
];

// Imágenes decorativas (micrófonos / estudio únicamente)
export const decorImages = {
  heroMic: "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  studio: "https://images.unsplash.com/photo-1518972559570-7cc1309f3229?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
